import PageTitle from "./page_title";

export { PageTitle };
